import  { useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { SingleScheduledUpcomingInterviewsDetailsType } from "../../../redux/thinksToDo/thinksToDoType";
import {
  SendApprovalStatusPayloadType,
  SingleScheduledUpcomingInterviewsDeatilsPayloadType,
} from "../../../commonTypes/thinksToDoTypes";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import {
  resetThinksToDoError,
  resetThinksToDoMessage,
  resetThinksToDoStatusCode,
  resetThinksToDoSuccess,
  sendApprovalStatusAction,
  singleScheduledUpcomingInterviewsDetailsAction,
} from "../../../redux/thinksToDo";
import { getAllFinacUsersAction, resetSession } from "../../../redux/auth";
import { ErrorSuccessModal, Loader } from "../../commons";
import toast from "react-hot-toast";
import { formatDate } from "../../../utils/commonFunctions";
import {
  ApprovalListPayloadType,
  FilterOffsetType,
  FilterTextType,
  FilterValueType,
  MultiSelectDataType,
  RecruitmentSortingType,
} from "../../../commonTypes/hrmsTypes";
import {
  getApprovalListAction,
  resetApprovalList,
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsSuccess,
} from "../../../redux/hrms";
import { ApprovalListType } from "../../../redux/hrms/hrmsTypes";
import FeedBackModal from "../FeedBackModal";
import PendingApprovalTableList from "../PendingApprovalTableList/PendingApprovalTableList";
import { SearchIcon } from "../../Icon";
import PendingApprovalFilter from "../PendingApprovalFilter";
import {
  getAllMasterDataBranchAction,
  resetMasterDataLisitng,
} from "../../../redux/masterData";
import { GetAllMasterDataBranchPayloadType } from "../../../commonTypes/masterDataTypes";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import useDebounce from "../../../customHooks/useDebounce";
import PendingApprovalSorting from "./PendingApprovalSorting";
type AppProps = {
  history: any;

  token: string | null;
  fetching: boolean;
  singleScheduledUpcomingInterviewsDetails: SingleScheduledUpcomingInterviewsDetailsType;
  totalCount: number;
  dispatchSingleScheduledUpcomingInterviewsDetails: (
    data: SingleScheduledUpcomingInterviewsDeatilsPayloadType
  ) => void;
  loginData: LoginResponseType;

  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;

  hrmsStatusCode: number | null;
  hrmsSuccess: number | null;
  hrmsError: string | null;
  // hrmsMessage: string | null;
  dispatchResetSession: () => void;
  dispatchResetThinksToDoError: () => void;
  dispatchResetThinksToDoMessage: () => void;
  dispatchResetThinksToDoStatusCode: () => void;
  dispatchResetThinksToDoSuccess: () => void;
  // dispatchResetScheduledUpcomingInterviewsList: () => void;
  dispatchApprovalListAction: (data: ApprovalListPayloadType) => void;
  updateFetching: boolean;
  approvalList: ApprovalListType[] | [];
  dispatchApprovalStatusAction: (data: SendApprovalStatusPayloadType) => void;
  thinksToDoFetching: boolean;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  dispatcResetApprovalList: () => void;
  dispatchResetMasterDataListing: () => void;
  dispatchGetMasterDataBranch: (
    data: GetAllMasterDataBranchPayloadType
  ) => void;
  masterDataListing: [];
  masterDataBranchListTotal: string | number;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  finacUser: any;
  totalUserCount: string | number;
};
const PendingApprovalList = ({
  history,
  token,
  fetching,
  singleScheduledUpcomingInterviewsDetails,
  totalCount,
  dispatchSingleScheduledUpcomingInterviewsDetails,
  loginData,
  hrmsStatusCode,
  hrmsSuccess,
  hrmsError,
  // hrmsMessage,
  statusCode,
  success,
  error,
  message,
  dispatchResetSession,
  dispatchResetThinksToDoError,
  dispatchResetThinksToDoMessage,
  dispatchResetThinksToDoStatusCode,
  dispatchResetThinksToDoSuccess,
  // dispatchResetScheduledUpcomingInterviewsList,
  updateFetching,
  dispatchApprovalListAction,
  approvalList,
  dispatchApprovalStatusAction,
  thinksToDoFetching,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsMessage,
  dispatchResetHrmsError,
  dispatcResetApprovalList,
  dispatchResetMasterDataListing,
  dispatchGetMasterDataBranch,
  masterDataListing,
  masterDataBranchListTotal,
  dispatchGetAllFinacUsersAction,
  finacUser,
  totalUserCount,
}: AppProps) => {
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [singleId, setSingleId] = useState("");
  const [singleScheduledDetails, setSingleScheduledDetails] = useState<any>({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<[] | ApprovalListType[]>([]);
  const [isApproved, setIsApproved] = useState(true);
  const [isInterviewApproval, setIsInterviewApproval] = useState(false);
  const [isInterViewApprovalComment, setIsInterViewApprovalComment] =
    useState("");
  const [approvalId, setApprovalId] = useState("");
  const [filterValue, setFilterValue] = useState<FilterValueType>({
    location: { name: "", value: "" },
    recuriter: { name: "", value: "" },
    progress: { name: "", value: "" },
    experience: null,
    status: { name: "", value: "" },
  });
  const [multiSelectData, setMultiSelectData] = useState<MultiSelectDataType>({
    filterStartDate: "",
    filterEndDate: "",
    location: { name: "", value: "" },
    recuriter: { name: "", value: "" },
    progress: { name: "", value: "" },
    experience: null,
    status: { name: "", value: "" },
  });
  const [sortBy, setSortBy] = useState<RecruitmentSortingType>({
    name: "Newest First",
    value: "desc",
    id: "Recently Modified First",
    _id: "approved_at",
  });
  const [filterOffset, setFilterOffset] = useState<FilterOffsetType>({
    locationOffset: 0,
    recuriterOffset: 0,
  });
  const [filterText, setFilterText] = useState<FilterTextType>({
    locationText: "",
    recuriterText: "",
  });
  const [toggle, setToggle] = useState<boolean>(false);
  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  const [filterStartDate, setFilterStartDate] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filterEndDate, setFilterEndDate] = useState<string>("");
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [branchFinalData, setBranchFinalData] = useState<any>([]);
  useEffect(() => {
    dispatchResetThinksToDoError();
    dispatchResetThinksToDoMessage();
    dispatchResetThinksToDoStatusCode();
    dispatchResetThinksToDoSuccess();
    dispatchResetHrmsSuccess();
    dispatchResetHrmsMessage();
    dispatchResetHrmsError();
    dispatchResetMasterDataListing();
    // dispatchResetScheduledUpcomingInterviewsList();
  }, []);

  useEffect(() => {
    if (token) {
      const finalData = {
        token,
        limit,
        offset,
        type: "things_to_do",
        approver_id: loginData?.user_id,
        sort_by: sortBy?._id,
        sorting_order: sortBy?.value,
        ////
        progress: filterValue?.progress?.value,
        recruiter: +filterValue?.recuriter?.value,
        location: filterValue?.location?.value,
        start_date: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        // experience: filterValue?.experience,

        status: filterValue?.status?.value,
      };

      if (totalCount) {
        if (offset < +totalCount) {
          dispatchApprovalListAction(finalData);
        }
      } else {
        dispatchApprovalListAction(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: filterOffset?.locationOffset,
        limit: limit,
        search_term: filterText?.locationText,
      };
      if (filterOffset?.locationOffset <= +masterDataBranchListTotal) {
        dispatchGetMasterDataBranch(finalUserData);
      }
    }
  }, [filterOffset?.locationOffset]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: filterOffset?.recuriterOffset,
        limit: limit,
        user_type: "stco_users",
        status: 1,
        search_term: filterText?.recuriterText,
      };
      if (filterOffset?.recuriterOffset <= +totalUserCount) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [filterOffset?.recuriterOffset]);

  useEffect(() => {
    const finalBranchData = masterDataListing?.map((user: any) => {
      return {
        value: user?.branch_name,
        label: user?.branch_name,
      };
    });
    if (filterOffset?.locationOffset > 0 && masterDataListing?.length) {
      setBranchFinalData([...branchFinalData, ...finalBranchData]);
    } else {
      setBranchFinalData(finalBranchData);
    }
  }, [masterDataListing]);

  useEffect(() => {
    if (feedbackModal && token) {
      let finalData = {
        token,
        id: singleId,
        type: "things_to_do",
      };
      dispatchSingleScheduledUpcomingInterviewsDetails(finalData);
    }
    if (!feedbackModal) {
      setIsInterviewApproval(false);
    }
  }, [feedbackModal]);

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name} ${user?.last_name}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (filterOffset?.recuriterOffset > 0 && finalUserList?.length) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  const handleFeedBackModal = (data?: string) => {
    setFeedbackModal(!feedbackModal);
    if (data) {
      setSingleId(data);
    } else {
      setSingleId("");
    }
  };
  useEffect(() => {
    if (approvalList?.length === 0) {
      setData(approvalList);
    } else if (offset > 0 && approvalList?.length > 0 && !fetching) {
      setData((prv: any) => [...prv, ...approvalList]);
    } else {
      setData(approvalList);
    }
  }, [approvalList]);
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (approvalList?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (
      singleScheduledUpcomingInterviewsDetails &&
      Object.keys(singleScheduledUpcomingInterviewsDetails)
    ) {
      setSingleScheduledDetails({
        ...singleScheduledUpcomingInterviewsDetails,
      });
    }
  }, [singleScheduledUpcomingInterviewsDetails]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [approvalList]);

  const handleErrorModal = () => {
    if (success === 0 || hrmsSuccess === 0) {
      if (
        statusCode === 401 &&
        error &&
        error === "You are not authorized to approve or reject this request."
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="You are not authorized to approve or reject this request."
            buttonText="OK"
            statusCode={statusCode}
            onPress={() => {
              dispatchResetThinksToDoError();
              dispatchResetHrmsError();
            }}
          />
        );
      }

      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (hrmsStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!hrmsError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={hrmsStatusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetThinksToDoError();
            }}
          />
        );
      } else if (!!hrmsError && hrmsStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!hrmsError}
            title="Error"
            message={hrmsError}
            buttonText="OK"
            onPress={() => {
              dispatchResetThinksToDoError();
            }}
          />
        );
      }
    } else if (
      message === "Recruitment details has been updated successfully."
    ) {
      toast.success("Feedback have been added successfuly", {
        duration: 2000,
      });

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      // dispatchResetScheduledUpcomingInterviewsList();
      if (token) {
        const finalData = {
          token,
          search_term: searchTerm,
          limit,
          offset: 0,
          sort_by: sortBy?._id,
          sorting_order: sortBy?.value,
          progress: filterValue?.progress?.value,
          recruiter: +filterValue?.recuriter?.value,
          location: filterValue?.location?.value,
          start_date: filterStartDate
            ? formatDate(filterStartDate)
            : filterStartDate,
          end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
          // experience: filterValue?.experience,
          type: "things_to_do",
          approver_id: loginData?.user_id,
          status: filterValue?.status?.value,
        };

        if (offset === 0) {
          dispatchApprovalListAction(finalData);
        } else {
          setOffset(0);
        }
      }
    } else if (message === "Recruitment approval request has been rejected.") {
      toast.success("Recruitment approval request has been rejected", {
        duration: 2000,
      });

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      if (token) {
        const finaDataApprovalList = {
          token,
          search_term: searchTerm,
          limit,
          offset: 0,
          sort_by: sortBy?._id,
          sorting_order: sortBy?.value,
          progress: filterValue?.progress?.value,
          recruiter: +filterValue?.recuriter?.value,
          location: filterValue?.location?.value,
          start_date: filterStartDate
            ? formatDate(filterStartDate)
            : filterStartDate,
          end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
          // experience: filterValue?.experience,
          type: "things_to_do",
          approver_id: loginData?.user_id,
          status: filterValue?.status?.value,

          // today: reverseDate(currentDate()),
        };
        dispatchApprovalListAction(finaDataApprovalList);
      }
    } else if (message === "Recruitment approval request has been approved.") {
      toast.success("Recruitment approval request has been approved.", {
        duration: 2000,
      });

      dispatchResetThinksToDoError();
      dispatchResetThinksToDoMessage();
      dispatchResetThinksToDoStatusCode();
      dispatchResetThinksToDoSuccess();
      if (token) {
        const finaDataApprovalList = {
          approver_id: loginData?.user_id,
          token,
          type: "things_to_do",
          offset: 0,
          sort_by: sortBy?._id,
          sorting_order: sortBy?.value,
          progress: filterValue?.progress?.value,
          recruiter: +filterValue?.recuriter?.value,
          location: filterValue?.location?.value,
          start_date: filterStartDate
            ? formatDate(filterStartDate)
            : filterStartDate,
          end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,

          status: filterValue?.status?.value,
          // today: reverseDate(currentDate()),
        };
        dispatchApprovalListAction(finaDataApprovalList);
      }
    }

    return false;
  };

  const handleSubmitFeedback = () => {
    if (isInterviewApproval && token) {
      const finalData = {
        token,
        _id: approvalId,
        comment: isInterViewApprovalComment,
        status: isApproved ? 3 : 2,
      };
      dispatchApprovalStatusAction(finalData);
      handleFeedBackModal();
    } else if (token) {
      let interviewDetailsRounds =
        singleScheduledDetails?.interview_details?.interview_round_details?.map(
          (el: any) => {
            return {
              ...el,
              interviewer: el.interviewer?.user_id,
            };
          }
        );
      const finalData = {
        token,
        finalData: {
          ...singleScheduledUpcomingInterviewsDetails,
          id: singleScheduledUpcomingInterviewsDetails?._id,
          position_details: {
            ...singleScheduledUpcomingInterviewsDetails?.position_details,
            job_position:
              singleScheduledUpcomingInterviewsDetails?.position_details?.job_position?.id.toString(),
            job_location:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.job_location?.id,
            recruiter:
              singleScheduledUpcomingInterviewsDetails?.position_details
                ?.recruiter?.user_id,
          },
          interview_details: {
            ...singleScheduledUpcomingInterviewsDetails?.interview_details,
            application_date: formatDate(
              singleScheduledUpcomingInterviewsDetails?.interview_details
                ?.application_date
            ),
            screening_details: {
              ...singleScheduledUpcomingInterviewsDetails?.interview_details
                ?.screening_details,
              phone_screener:
                singleScheduledUpcomingInterviewsDetails?.interview_details
                  ?.screening_details?.phone_screener?.user_id,
            },
            interview_round_details: [...interviewDetailsRounds],
          },
          other_details: {
            ...singleScheduledUpcomingInterviewsDetails?.other_details,
            referred_by:
              singleScheduledUpcomingInterviewsDetails?.other_details
                ?.referred_by?.user_id,
          },
        },
      };
      // dispatchUpdateRecruitmentTrackerListAction(finalData);
      handleFeedBackModal();
    }
  };

  const handleFeedBackAdded = (data: string) => {
    if (isInterviewApproval) {
      setIsInterViewApprovalComment(data);
    }
    let updatedInterviewRoundDetails = [
      ...singleScheduledUpcomingInterviewsDetails?.interview_details
        ?.interview_round_details,
    ];

    let lastInterview =
      updatedInterviewRoundDetails[updatedInterviewRoundDetails.length - 1];

    let updatedLastInterview = {
      ...lastInterview,
      is_feedback_submited: true,
      interview_feedback: data,
    };

    updatedInterviewRoundDetails[updatedInterviewRoundDetails.length - 1] =
      updatedLastInterview;

    setSingleScheduledDetails({
      ...singleScheduledUpcomingInterviewsDetails,
      interview_details: {
        ...singleScheduledUpcomingInterviewsDetails?.interview_details,
        interview_round_details: updatedInterviewRoundDetails,
      },
    });
  };
  const handleApplyFilter = () => {
    dispatcResetApprovalList();
    setData([]);
    setMultiSelectData({
      filterStartDate,
      filterEndDate,
      location: filterValue?.location,
      progress: filterValue?.progress,
      experience: filterValue?.experience,
      recuriter: filterValue?.recuriter,
      status: filterValue?.status,
    });

    setFilterOffset({ locationOffset: 0, recuriterOffset: 0 });

    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        sort_by: sortBy?._id,
        sorting_order: sortBy?.value,
        progress: filterValue?.progress?.value,
        recruiter: +filterValue?.recuriter?.value,
        location: filterValue?.location?.value,
        start_date: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        // experience: filterValue?.experience,
        type: "things_to_do",
        approver_id: loginData?.user_id,
        status: filterValue?.status?.value,
      };
      dispatchApprovalListAction(finalData);
    }
  };
  const handleFilterClear = () => {
    delete history?.location?.state?.multiSelectData;
    dispatcResetApprovalList();
    setData([]);
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        sort_by: sortBy?._id,
        sorting_order: sortBy?.value,
        progress: "",
        recruiter: "",
        location: "",
        start_date: "",
        end_date: "",
        // experience: filterValue?.experience,
        type: "things_to_do",
        approver_id: loginData?.user_id,
      };
      dispatchApprovalListAction(finalData);
    }
    setMultiSelectData({
      filterStartDate: "",
      filterEndDate: "",
      location: { name: "", value: "" },
      recuriter: { name: "", value: "" },
      progress: { name: "", value: "" },
      experience: null,
    });
  };

  useDebounce(
    () => {
      if (searchTerm) {
        fetchNewData();
      } else {
        setOffset(0);
      }
    },
    500,
    [searchTerm]
  );

  const fetchNewData = () => {
    dispatcResetApprovalList();
    setData([]);
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        sort_by: sortBy?._id,
        sorting_order: sortBy?.value,
        progress: filterValue?.progress?.value,
        recruiter: +filterValue?.recuriter?.value,
        location: filterValue?.location?.value,
        start_date: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        // experience: filterValue?.experience,
        type: "things_to_do",
        approver_id: loginData?.user_id,
        status: filterValue?.status?.value,
      };
      if (offset === 0) {
        dispatchApprovalListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchTerm(value);

    if (value?.length === 0) {
      let finalData = {
        token,
        search_term: "",
        limit,
        offset: 0,
        sort_by: sortBy?._id,
        sorting_order: sortBy?.value,
        progress: filterValue?.progress?.value,
        recruiter: +filterValue?.recuriter?.value,
        location: filterValue?.location?.value,
        start_date: filterStartDate
          ? formatDate(filterStartDate)
          : filterStartDate,
        end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
        // experience: filterValue?.experience,
        type: "things_to_do",
        approver_id: loginData?.user_id,
        status: filterValue?.status?.value,
      };
      dispatchApprovalListAction(finalData);
    }
  };

  const handleSorting = (data: any) => {
    dispatcResetApprovalList();
    setData([]);
    setSortBy(data);
    if (offset > 0) {
      setOffset(0);
    } else {
      if (token) {
        let finalData = {
          token,
          search_term: searchTerm,
          limit,
          offset: 0,
          sort_by: data?._id,
          sorting_order: data?.value,
          progress: filterValue?.progress?.value,
          recruiter: +filterValue?.recuriter?.value,
          location: filterValue?.location?.value,
          start_date: filterStartDate
            ? formatDate(filterStartDate)
            : filterStartDate,
          end_date: filterEndDate ? formatDate(filterEndDate) : filterEndDate,
          // experience: filterValue?.experience,
          type: "things_to_do",
          approver_id: loginData?.user_id,
          status: filterValue?.status?.value,
        };
        dispatchApprovalListAction(finalData);
      }
    }
  };

  return (
    <>
      <div className="new-table-card pt-4">
        <div className="header">
          <div className="left-header">
            <div className="heading mb-0"> All Approval List</div>
            <div className="sub-heading">{`Total ${totalCount} applications found`}</div>
          </div>

          <div className="right-header">
            <div className="col-md-9 position-relative">
              <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                <SearchIcon />
              </span>
              <input
                className="form-control"
                type="text"
                placeholder="Search"
                onChange={(e: any) => handleSearch(e)}
                style={{ paddingLeft: "35px" }}
                value={searchTerm}
              />
            </div>

            <div className="mr-1">
              <PendingApprovalSorting
                setToggle={setToggle}
                toggle={toggle}
                selectedData={
                  sortBy?.value !== "desc" && sortBy?.name !== "Newest First"
                    ? sortBy
                    : { name: "Newest First", value: "desc" }
                }
                handleSorting={handleSorting}
              />
            </div>

            <div>
              <div className=" mr-1">
                <PendingApprovalFilter
                  setToggle={setFilterToggle}
                  toggle={filterToggle}
                  finalUserList={finalUserList}
                  setText={setFilterText}
                  fetching={fetching}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                  setFilterStartDate={setFilterStartDate}
                  setFilterEndDate={setFilterEndDate}
                  filterStartDate={filterStartDate}
                  filterEndDate={filterEndDate}
                  setFilterOffset={setFilterOffset}
                  setFilterText={setFilterText}
                  branchFinalData={branchFinalData}
                  multiSelectData={multiSelectData}
                  limit={limit}
                  handleApplyFilter={handleApplyFilter}
                  handleFilterClear={handleFilterClear}
                />
              </div>
            </div>
          </div>
        </div>
        <PendingApprovalTableList
          data={data}
          fetching={fetching}
          handleFeedBackModal={handleFeedBackModal}
          offset={offset}
          setIsApproved={setIsApproved}
          isApproved={isApproved}
          setIsInterviewApproval={setIsInterviewApproval}
          setApprovalId={setApprovalId}
        />
      </div>

      {feedbackModal && (
        <FeedBackModal
          toggle={handleFeedBackModal}
          isOpen={feedbackModal}
          data={singleScheduledUpcomingInterviewsDetails}
          hanldeFeedback={handleFeedBackAdded}
          handleSubmitFeedback={handleSubmitFeedback}
          loginData={loginData}
          fetching={thinksToDoFetching}
          isInterviewApproval={isInterviewApproval}
          isApproved={isApproved}
          setIsApproved={setIsApproved}
          approvalId={approvalId}
          type={"finaccrm"}
        />
      )}
      {handleErrorModal()}
      {updateFetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  scheduledUpcomingInterviewsList: state.thinksToDo.scheduledUpcomingInterviews,
  fetching: state.thinksToDo.fetching,
  singleScheduledUpcomingInterviewsDetails:
    state.thinksToDo.singleScheduledUpcomingInterviewsDetails,
  totalCount: state.hrms.approvalTotalCount,
  loginData: state.auth.loginData,
  error: state.thinksToDo.error,
  statusCode: state.thinksToDo.statusCode,
  success: state.thinksToDo.success,
  message: state.thinksToDo.message,
  updateFetching: state.thinksToDo.updateFetching,
  hrmsSuccess: state.hrms.success,
  hrmsStatusCode: state.hrms.statusCode,
  hrmsError: state.hrms.error,
  hrmsMessage: state.hrms.message,
  approvalList: state.hrms.approvalList,
  thinksToDoFetching: state.thinksToDo.fetching,
  masterDataListing: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  finacUser: state.auth.finacUsersList,
  totalUserCount: state.auth.totalUserCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSingleScheduledUpcomingInterviewsDetails: (
    data: SingleScheduledUpcomingInterviewsDeatilsPayloadType
  ) => dispatch(singleScheduledUpcomingInterviewsDetailsAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetThinksToDoError: () => dispatch(resetThinksToDoError()),
  dispatchResetThinksToDoMessage: () => dispatch(resetThinksToDoMessage()),
  dispatchResetThinksToDoStatusCode: () =>
    dispatch(resetThinksToDoStatusCode()),
  dispatchResetThinksToDoSuccess: () => dispatch(resetThinksToDoSuccess()),
  dispatchApprovalListAction: (data: ApprovalListPayloadType) =>
    dispatch(getApprovalListAction(data)),
  dispatchApprovalStatusAction: (data: SendApprovalStatusPayloadType) =>
    dispatch(sendApprovalStatusAction(data)),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatcResetApprovalList: () => dispatch(resetApprovalList()),
  dispatchResetMasterDataListing: () => dispatch(resetMasterDataLisitng()),
  dispatchGetMasterDataBranch: (data: GetAllMasterDataBranchPayloadType) => {
    dispatch(getAllMasterDataBranchAction(data));
  },
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingApprovalList);
